<template>
    <div class="viewMode">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Area destination</strong>
                    </div>
                    <div class="form-container">
                        <b-row>
                            <b-col sm="12">
                                <div class="mb-3">
                                    <CompanyAreaSelection v-on:company-selected="selectedCompany" v-on:area-selected="selectedArea" :company-id="targetCompanyId" />
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Sites to move</strong>
                    </div>
                    <div class="form-container">
                        <p>
                            The following sites will be moved:
                        </p>
                        <b-row>
                            <b-col sm="12">
                                <div class="mb-3">
                                    <strong>Site Name</strong>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row v-for="site in sites" v-bind:key="site.id" class="output-row">
                            <b-col sm="12">
                                <b-input-group>
                                    <b-form-input
                                        v-model="site.site_name"
                                        type="text"
                                        class="form-control"
                                        :id="'site-' + site.id"
                                        readonly
                                    ></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row>
                    </div>
                    <b-row>
                        <b-col>
                            <p>
                                <b-button variant="primary" @click="triggerMoveProcess">
                                    <i class="fa fa-check"></i>&nbsp;Selection Complete
                                </b-button>
                            </p>
                            <div v-if="targetAreaError" class="viewMode">
                                <b-alert variant="danger" show><strong>An Area must be selected</strong></b-alert>
                            </div>
                            <div v-if="dataCommitComplete" class="viewMode">
                                <b-alert variant="success" show><strong>Site move complete</strong></b-alert>
                            </div>
                        </b-col>
                    </b-row>
                    <div v-if="commitProcessRunning" class="form-container">                    
                        <h4>Working...</h4>
                        <b-progress :value="dataCommitProgress" :max="dataCommitMax" show-progress animated class="mb-3"></b-progress>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>

import SitesService from '@/services/sites-service.js';
import LoadingSpinner from '@/components/loadingSpinner/LoadingSpinner';
import CompanySelection from '@/components/common/CompanySelection.vue';
import CompanyAreaSelection from '@/components/common/CompanyAreaSelection.vue';


export default {
    name: 'SiteMoveProcess',
    props: ['selected-sites'],
    emits: ['move-completed'],
    components: {
        LoadingSpinner: LoadingSpinner,
        CompanySelection: CompanySelection,
        CompanyAreaSelection: CompanyAreaSelection
    },
    data () {
        return {
            sites: [],
            commitProcessRunning: false,
            targetCompanyId: 0,
            targetCompanyError: false,
            targetAreaId: 0,
            targetAreaError: false,
            dataCommitProgress: 0,
            dataCommitMax: 1,
            dataCommitComplete: false
        }
    },
    async created() {
        this.$data.sites = this.selectedSites;
    },
    methods: {
        selectedCompany(company) {
            this.$data.targetCompanyId = company;
        },
        selectedArea(area) {
            this.$data.targetAreaId = area;
        },
        async triggerMoveProcess() {
            this.$data.targetCompanyError = false;
            this.$data.targetAreaError = false;
            
            if (this.$data.targetAreaId >= 1) {
                this.$data.targetAreaError = false;
                this.$data.commitProcessRunning = true;
                
                this.$data.dataCommitMax = this.$data.sites.length;

                // send the data to the api
                this.$data.dataCommitProgress = 0;
                for (let item = 1; item <= this.$data.sites.length; item++) {
                    let siteToSend = JSON.parse(JSON.stringify(this.$data.sites[item - 1]));
                    siteToSend.area_id = this.$data.targetAreaId;
                    siteToSend.company_id = this.$data.targetCompanyId;
                    
                    await SitesService.updateSite(siteToSend, siteToSend.id);
                    this.$data.dataCommitProgress++;
                };

                // flag the process as complete
                setTimeout(() => {
                    this.$data.commitProcessRunning = false;
                    this.$data.dataCommitComplete = true;
                }, 1000);
                setTimeout(() => {
                    this.$emit('move-completed');
                }, 3000);
            }
            else {
                this.$data.targetAreaError = true;
                this.$data.commitProcessRunning = false;
            }
        }
    }
}

</script>

<style scoped>
.row.output-row {
    padding-bottom: 8px;
}
</style>
